import { Shell } from "./Shell";
import { Hero } from "./Hero";
import { HowHarc, ImpactStories, Approach, Insights, FinalCta } from "./Sections";

export default function Mockup() {
  return (
    <Shell>
      <Hero />
      <HowHarc />
      <ImpactStories />
      <Approach />
      <Insights />
      <FinalCta />
    </Shell>
  );
}
